export function StagLogo({ size = 48, className = "", glow = true }) {
  return (
    <img
      src="/stag-vault-emblem-v2.webp"
      alt="Stag Vault"
      width={size}
      height={size}
      className={className}
      style={{
        display: "inline-block",
        objectFit: "contain",
        filter: glow ? "drop-shadow(0 0 12px rgba(168, 85, 247, 0.45))" : undefined,
      }}
      draggable={false}
    />
  );
}
